const devEnv = {
  "dev.btoolsb.com": {
    CENTRAL_DOMAIN: [
      "127.0.0.1",
      "localhost",
      "btoolsb.com",
      "qa.btoolsb.com",
      "dev.btoolsb.com",
    ],
    API_URL: "https://dev.btoolsb.com/api",
    KEYCLOAK_JSON: {
      realm: "btoolsb",
      "auth-server-url": "https://keycloak.dev.btoolsb.com/",
      "ssl-required": "external",
      resource: "btoolsb-frontend",
      "public-client": true,
      "confidential-port": 0,
    },
  },
  "sgp.dev.btoolsb.com": {
    CENTRAL_DOMAIN: [
      "127.0.0.1",
      "localhost",
      "btoolsb.com",
      "qa.btoolsb.com",
      "dev.btoolsb.com",
    ],
    API_URL: "https://sgp.dev.btoolsb.com:8000/api",
    KEYCLOAK_JSON: {
      realm: "sgp",
      "auth-server-url": "https://keycloak.dev.btoolsb.com/",
      "ssl-required": "external",
      resource: "btoolsb-frontend",
      "public-client": true,
      "confidential-port": 0,
    },
  },
  "tenantprandra.dev.btoolsb.com": {
    CENTRAL_DOMAIN: [
      "127.0.0.1",
      "localhost",
      "btoolsb.com",
      "qa.btoolsb.com",
      "dev.btoolsb.com",
    ],
    API_URL: "http://tenantprandra.dev.btoolsb.com:8000/api",
    KEYCLOAK_JSON: {
      realm: "sgp",
      "auth-server-url": "https://keycloak.dev.btoolsb.com/",
      "ssl-required": "external",
      resource: "btoolsb-frontend",
      "public-client": true,
      "confidential-port": 0,
    },
  },
  "sgd.dev.btoolsb.com": {
    CENTRAL_DOMAIN: [
      "127.0.0.1",
      "localhost",
      "btoolsb.com",
      "qa.btoolsb.com",
      "dev.btoolsb.com",
    ],
    API_URL: "https://sgd.dev.btoolsb.com:8000/api",
    KEYCLOAK_JSON: {
      realm: "sgd",
      "auth-server-url": "https://keycloak.dev.btoolsb.com/",
      "ssl-required": "external",
      resource: "btoolsb-frontend",
      "public-client": true,
      "confidential-port": 0,
    },
  },
  "ttr.dev.btoolsb.com": {
    CENTRAL_DOMAIN: [
      "127.0.0.1",
      "localhost",
      "btoolsb.com",
      "qa.btoolsb.com",
      "dev.btoolsb.com",
    ],
    API_URL: "https://ttr.dev.btoolsb.com:8000/api",
    KEYCLOAK_JSON: {
      realm: "ttr",
      "auth-server-url": "https://keycloak.dev.btoolsb.com/",
      "ssl-required": "external",
      resource: "btoolsb-frontend",
      "public-client": true,
      "confidential-port": 0,
    },
  },
};
export default devEnv;
